<template>
  <div class="xnews wd500 ht400 bgw pl15 pr20 pt20 dinline-block br5 vtop ml10 mr10">
    <div class="st bborder pb5">
      <router-link to="/evn/list?id=0&pid=2" class="more fr tc6 br30 mt5 trans3">更多 +</router-link>
      <div class="dinline-block">
        <div class="sst fs24 mr5 dinline-block prelative">
          <span class="img-news img-bg dinline-block vcenter"></span>
          校园新闻
        </div>
        <span class="farial tc9 tupper">News</span>
      </div>
    </div>
    <div class="cont pt20 pl5">
      <div class="slideBox" id="slideBox">
        <ul class="items" v-if="items">
          <li class="active" v-for="(item,index) in items" v-if="getImg(item.content) > ''">
            <router-link :to="`/evn/detail?id=0&pid=2&num=${index}&article_id=${item.id}`" :title="item.title">
              <img :src="getImg(item.content)">
            </router-link>
          </li>
        </ul>

<!--        <ul class="items" v-if="items">-->
<!--          <li class="active">-->
<!--            <a href="#" title="这里是测试标题一">-->
<!--              <img src="../../assets/images/index_04_02.jpg">-->
<!--            </a>-->
<!--          </li>-->
<!--          <li class="active">-->
<!--            <a href="#" title="这里是测试标题一">-->
<!--              <img src="../../assets/images/index_04_02.jpg">-->
<!--            </a>-->
<!--          </li>-->
<!--          <li class="active">-->
<!--            <a href="#" title="这里是测试标题一">-->
<!--              <img  src="../../assets/images/index_04_02.jpg">-->
<!--            </a>-->
<!--          </li>-->
<!--        </ul>-->
      </div>
    </div>
  </div>
</template>

<script>
import '../../../static/slidebox/jquery.slideBox.css'
import '../../../static/slidebox/jquery.slideBox.min.js'
export default {
  name: "News",
  props:[
    'items'
  ],
  mounted() {
    this.slideBox();
  },
  updated() {
    console.log(this.items);
    this.slideBox();
  },
  methods:{
    getImg(html){
      var arr = html.match(/src="http(.*?)"/i)
      var res = '';
      if(arr != null){
        res = 'http'+arr[1];
      }
      return res;
    },
    slideBox(){
      this.$nextTick(()=>{
        $('#slideBox').slideBox({
          duration : 0.3,//滚动持续时间，单位：秒
          easing : 'linear',//swing,linear//滚动特效
          delay : 5,//滚动延迟时间，单位：秒
          hideClickBar : false,//不自动隐藏点选按键
          clickBarRadius : 10
        });
      })
    },
  }
}
</script>

<style>
.xnews{margin-left: 11px;}
.xnews .slideBox{width: 100%;height: 315px;}
.xnews .slideBox img{width: 460px;height: 300px;object-fit: cover;}
.xnews .slideBox .tips{height: 40px;}
.xnews .slideBox div.tips div.title a{line-height: 40px;font-weight: bold;}
.xnews .slideBox div.tips div.nums{right: 15px;}
.xnews .slideBox div.tips div.nums a.active{background: #f20405;}
.xnews .slideBox div.tips div.nums a{margin-right: 5px;margin-top: 16px;width: 9px;height: 9px;border-radius: 50% !important;}
</style>



// WEBPACK FOOTER //
// src/components/index/News.vue